import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ShortCartComponent } from './short-cart/short-cart.component';
import { EsSearchBoxComponent } from './es-search-box/es-search-box.component';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/app/pipes/pipes.module';
// import { NgSelectModule } from "@ng-select/ng-select";







@NgModule({
  imports: [
    PipesModule,
    CommonModule,
    IonicModule,
    FormsModule,
    NgxPaginationModule,
    TranslateModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    ShortCartComponent,
    EsSearchBoxComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ShortCartComponent,
    EsSearchBoxComponent,
  ],
})
export class HeaderFooterComponentsModule {}
